export class files
{
    name:string;
    fileList:FileList;
}